<template lang="pug">
  div
    .attention(v-if='values.attention_level && versions !== variables.V1')
      img.attention_icons(v-if='values.attention_level === "red" && values.gender === 1' src='@/assets/attention/red_men.svg')
      img.attention_icons(v-if='values.attention_level === "red" && values.gender === 2' src='@/assets/attention/red_women.svg')
      img.attention_icons(v-if='values.attention_level === "red" && values.gender === 3' src='@/assets/attention/red_noname.svg')
      img.attention_icons(v-if='values.attention_level==="green" && values.gender === 1' src='@/assets/attention/green_men.svg')
      img.attention_icons(v-if='values.attention_level==="green" && values.gender === 2' src='@/assets/attention/green_women.svg')
      img.attention_icons(v-if='values.attention_level==="green" && values.gender === 3' src='@/assets/attention/green_noname.svg')
      img.attention_icons(v-if='values.attention_level==="yellow" && values.gender === 1' src='@/assets/attention/yellow_men.svg')
      img.attention_icons(v-if='values.attention_level==="yellow" && values.gender === 2' src='@/assets/attention/yellow_women.svg')
      img.attention_icons(v-if='values.attention_level==="yellow" && values.gender === 3' src='@/assets/attention/yellow_noname.svg')
      .attention_body
        span.header_green(v-if='values.attention_level === "red"') {{'пациент высокого уровня внимания' | uppercase}}
        span.header_green(v-if='values.attention_level === "yellow"') {{'пациент умеренного уровня внимания' | uppercase}}
        span.header_green(v-if='values.attention_level === "green"') {{'пациент низкого уровня внимания' | uppercase}}
        .attention_body_items
          .attention_items
            .attention_item
              .attention_item_header Пол: &nbsp;
              .attention_item_value(v-if="values.gender") {{values.gender | gender}} &nbsp;
            .attention_item
              .attention_item_header Возраст: &nbsp;
              .attention_item_value(v-if="values.birthdate") {{values.medical_data.age | age}} &nbsp;
            .attention_item(v-if="values.patient_state")
              .attention_item_header Состояние: &nbsp;
              .attention_item_value {{value.patient_state_text || '—'}}

    .tabs(v-for="(result, index) in nosology")
      .tab(@click="showTabContent(index)" :class="{'tab_active': contentObj[index]}" :id='"nosology_" + index' v-if="tabDisplayCondition(result)")

        .nosology_icons(v-if="result.nosology.images" v-html='result.nosology.images')
        img.nosology_icons(v-if='!result.nosology.images' src='@/assets/svg/exclamation.svg')
        span {{result.nosology.text + ": " | uppercase }}
        span.risk_status_wrapper(:class="{'no_risk': result.nosology.risk_group.code == 1, 'low_risk': result.nosology.risk_group.code == 2, 'medium_risk': result.nosology.risk_group.code == 3, 'high_risk': result.nosology.risk_group.code == 4, 'very_high_risk': result.nosology.risk_group.code == 5, 'no_data': result.nosology.risk_group.code == 0 }") {{result.nosology.risk_group.text | uppercase}}
        span.tab_icon
          v-icon.i(v-if="!contentObj[index]" name="angle-right" scale="1.3")
          v-icon.i(v-if="contentObj[index]" name="angle-down" scale="1.3")
      transition(name="fade")
        .content(v-if="contentObj[index]")

          .item
            .content_header
              img.header_icon(src='@/assets/png/method.png')
              span.header_green МЕТОДИКИ ОЦЕНКИ
            .content_text(v-for="method in result.risk_methods")
              .score_wrapper
                img.icon_ai(v-if="((method.code == 16 || method.code == 17) && method.source !== 'classic') || method.source == ResultRiskMethodsSourceModel" src='@/assets/png/AI_2.png')
                div(:class='{score: method.risk_group_code > 1 && method.risk_group_code < 6, score_not_work: method.risk_group_code == 1 || method.risk_group_code == 0}' v-html='method.text')
              .result(v-if='method.risk_group_text') {{method.risk_group_text}}
                span(v-if="method.value && method.value.match(/^:/)"  v-html='method.value')
                span(v-if="method.value && !method.value.match(/^:/)"  v-html='", " + (method.value)')
              .result(v-if='!method.risk_group_text') {{method.value}}

          .item
            .content_header
              img.header_icon(src='@/assets/png/factor.png')
              span.header_green ФАКТОРЫ РИСКА
            .content_text(v-for="risk_factor in result.risk_factors")
              .result_text(v-if="risk_factor.value" v-html="(risk_factor.text) + ' (' + (risk_factor.value) + ')' ")
              .result_text(v-else v-html="risk_factor.text")
            .content_text(v-if="!result.risk_factors || !result.risk_factors.length")
              .result_text Факторы риска не выявлены

          .item
            .content_header
              img.header_icon(src='@/assets/png/results.png')
              span.header_green ИНТЕРПРЕТАЦИЯ
            .content_text(v-if="result.nosology.description || (result.check_interpritation_exist && result.check_interpritation_exist.length)")
              .result_text(v-if="result.nosology.description !== null") {{result.nosology.description}}
              div(v-for="interpritation in result.check_interpritation_exist")
                .result_text(v-html="interpritation")
            .content_text(v-else)
              .result_text Признаков высокого риска не выявлено

          .item
            .content_header
              img.header_icon(src='@/assets/png/patient.png')
              span.header_green РЕКОМЕНДАЦИИ ПАЦИЕНТУ
            .content_text(v-if="result.nosology.patient_recommendations && result.nosology.patient_recommendations.text")
              .result_text(v-html="result.nosology.patient_recommendations.text")
            .content_text(v-else)
              .result_text Рекомендации отсутствуют

          .item
            .content_header
              img.header_icon(src='@/assets/png/doctor.png')
              span.header_green РЕКОМЕНДАЦИИ ВРАЧУ
            .content_text(v-if="result.nosology.doctor_recommendations && result.nosology.doctor_recommendations.text")
              .result_text(v-html="result.nosology.doctor_recommendations.text")
            .content_text(v-else)
              .result_text Рекомендации отсутствуют

    .tabs(v-if="versions !== variables.V1")
      .tab(v-if="is_set_drugs" @click="showTabContent(drug_index)" :class="{'tab_active': contentObj[drug_index]}" id='drags')
        img.nosology_icons(src='@/assets/svg/pills.svg')
        span {{'Оценка межлекарственного взаимодействия' + ": " | uppercase}}
        span.risk_status_wrapper(:class="medicineRiskGroup") {{drugs_title | uppercase}}
        span.tab_icon
          v-icon.i(v-if="!contentObj[drug_index]" name="angle-right" scale="1.3")
          v-icon.i(v-if="contentObj[drug_index]" name="angle-down" scale="1.3")
      transition(name="fade")
        div(v-if="contentObj[drug_index] && drugs_perm")
          .content(v-if="!values.ecp_integration_result")
            .content_header
              span.header_green.drugTitle Данных о назначенной лекарственной терапии не выявлено
          .content(v-if="values.ecp_integration_result && (!values.ecp_integration_result.response || !values.ecp_integration_result.response.elements)")
            .content_header
              span.header_green.drugTitle Оценка о назначенной лекарственной терапии отсутствует
          .content(v-if="values.ecp_integration_result && values.ecp_integration_result.response")
            div(v-for="(grugEl, index) in values.ecp_integration_result.response.elements")
              .content_header
                img.header_icon(src='@/assets/png/method.png')
                .header_green {{grugEl.send | uppercase}}
              .content_text(v-if="grugEl.conflict && grugEl.value_max != 'active_duplicate'")
                span.header_green.drugTitle(
                  @click="toggleConflicts(grugEl)"
                  :class="{'tab_active': contentDrugs[index]}"
                ) Выявлены риски взаимодействия с другими лекарственными средствами&nbsp;
                span.tab_icon
                  v-icon.i(v-if="grugEl.expanded" name="angle-right" scale="1.3")
                  v-icon.i(v-if="!grugEl.expanded" name="angle-down" scale="1.3")
                div(v-if="grugEl.expanded" v-for="conflict in grugEl.conflict")
                  .conflictTiesMain(v-if="conflict.idTies > 0")
                    b {{values.ecp_integration_result.response.descriptions[conflict.idTies].conflict_element_a}}  -  {{values.ecp_integration_result.response.descriptions[conflict.idTies].conflict_element_b}}
                    .conflictTies(v-if='values.ecp_integration_result.response.descriptions[conflict.idTies].descriptions')
                      span(v-if='values.ecp_integration_result.response.descriptions[conflict.idTies].descriptions.precautions' v-html='values.ecp_integration_result.response.descriptions[conflict.idTies].descriptions.precautions')
                      span(v-if='values.ecp_integration_result.response.descriptions[conflict.idTies].descriptions.interactions' v-html='values.ecp_integration_result.response.descriptions[conflict.idTies].descriptions.interactions')
                      span(v-if='values.ecp_integration_result.response.descriptions[conflict.idTies].descriptions.recommendations' v-html='values.ecp_integration_result.response.descriptions[conflict.idTies].descriptions.recommendations')
              .content_text(v-if="!grugEl.conflict || grugEl.value_max === 'active_duplicate'")
                span.header_green.drugTitle Рисков не выявлено

      .tab.tab-suspicions(@click="showTabContent(suspicions)" :class="{'tab_active': contentObj[suspicions]}" id='wrd_suspicions')
        img.nosology_icons(src='@/assets/png/search.png')
        span {{'Подозрения на заболевания' + ": " | uppercase}}
        span.risk_status_wrapper.low_risk(v-if="!value.suspicions") {{'Не выявлены' | uppercase}}
        span.risk_status_wrapper.high_risk(v-if="value.suspicions && value.suspicions.length>0") {{'Выявлены' | uppercase}}
        span.tab_icon
          v-icon.i(v-if="!contentObj[suspicions]" name="angle-right" scale="1.3")
          v-icon.i(v-if="contentObj[suspicions]" name="angle-down" scale="1.3")
      transition(name="fade")
        .content(v-if="contentObj[suspicions] && value.suspicions && value.suspicions.length>0")
          .content_header.tab-suspicions__header
            img.header_icon(src='@/assets/png/method.png')
            span.header_green ДИАГНОЗЫ
          .content_text.tab-suspicions__content(v-for="diagnos in value.suspicions")
            .tab-suspicions__content-row
              .images.tab-suspicions__row-mkb-images--item
                img.icon_ai(v-if="diagnos.source === SuspicionsDiagnosSourceModel" src='@/assets/png/AI_2.png')
                .icon_ai(v-if="diagnos.source !== SuspicionsDiagnosSourceModel")
              span.score.tab-suspicions__row-mkb-images--item {{diagnos.mkb_code}}
              .tab-suspicions__row-name.tab-suspicions__row-mkb-images--item {{diagnos.name}}
            .tab-suspicions__detail-row
              .tab-suspicions__document-link(v-if="diagnos.source && diagnos.document && diagnos.source == SuspicionsDiagnosSourceModel")
                router-link(:to = "{name: 'DocumentSummary', params: { id: values.id, doc_id: diagnos.document.id }}"  target="_blank") На основании документа {{diagnos.document.document_type}} от {{diagnos.document.date | date}}
              .tab-suspicions__symptom_diag(v-if="diagnos.symptoms && diagnos.symptoms.length") На основании выявленных симптомов:&nbsp;
                span(v-for='(symptom, index) in diagnos.symptoms')
                  span {{symptom.name}}
                  span(v-if='index + 1 < diagnos.symptoms.length') ,&nbsp;

</template>
<script>
import Icon from 'vue-awesome/components/Icon'
import store from '../../../store'
import variables, {SuspicionsDiagnosSourceModel,ResultRiskMethodsSourceModel} from '@/variables'

export default {
  components: {
    'v-icon': Icon
  },
  data () {
    return {
      value: false,
      is_set_drugs: false,
      drug_loading: false,
      contentObj: {},
      contentIndex: 0,
      nosology_index: 0,
      drug_index: false,
      suspicions: false,
      unique: [],
      nosology: [],
      groups: [],
      versions: 'v2',
      drugs_value: '10',
      drugs_title: 'Модуль не подключен',
      permissions: store.state.user.user.frontend_sections,
      drugs_perm: false,
      contentDrugs: {},
      SuspicionsDiagnosSourceModel,
      ResultRiskMethodsSourceModel,
      variables
    }
  },
  props: ['values'],
  created () {
    this.permissions.forEach(sections => {
      if (sections === 'ECP') this.drugs_perm = true
    })
    this.value = this.values
    this.versions = this.value.api_version
    if (this.value !== false) {
      this.setFttention()
      this.setData()
      this.showMaxRiskTab()
    } else {
      if (!this.values) console.log('error Values')
    }
  },
  methods: {
    setData () {
      if (this.value !== false) {
        // tabs nosology
        if (this.value.result && this.value.result.length) {
          this.value.result.forEach(element => {
            this.nosology.push(element)
            this.contentIndex += 1
          })
        }
        if (this.value.groups && this.value.groups.length) {
          this.value.groups.forEach(element => {
            this.groups.push(element)
          })
        }

        // tabs drags
        if (this.values.ecp_integration_result && this.values.ecp_integration_result.response) {
          if (this.values.ecp_integration_result.response.elements) {
            for (let elem in this.values.ecp_integration_result.response.elements) {
              this.contentDrugs[elem] = false
              if (this.values.ecp_integration_result.response.elements[elem].conflict && this.values.ecp_integration_result.response.elements[elem].conflict.length) {
                this.values.ecp_integration_result.response.elements[elem].openTabConflict = false
              }
            }
          }
          if (this.drugs_perm) {
            if (this.values.ecp_integration_result.response.warnings) {
              for (let key in this.values.ecp_integration_result.response.warnings) {
                if (this.drugs_value === '10' || this.drugs_value < this.values.ecp_integration_result.response.warnings[key].value_max) {
                  this.drugs_value = this.values.ecp_integration_result.response.warnings[key].value_max
                }
              }
            }
            if (this.values.ecp_integration_result.response.descriptions) {
              for (let element in this.values.ecp_integration_result.response.descriptions) {
                if (this.values.ecp_integration_result.response.descriptions[element].descriptions) {
                  for (let decs in this.values.ecp_integration_result.response.descriptions[element].descriptions) {
                    this.values.ecp_integration_result.response.descriptions[element].descriptions[decs] = this.values.ecp_integration_result.response.descriptions[element].descriptions[decs].replace(/<.*?>/g, '')
                  }
                }
                if (this.values.ecp_integration_result.response.descriptions[element].precautions) {
                  for (let decs in this.values.ecp_integration_result.response.descriptions[element].precautions) {
                    this.values.ecp_integration_result.response.descriptions[element].precautions[decs] = this.values.ecp_integration_result.response.descriptions[element].precautions[decs].replace(/<.*?>/g, '')
                  }
                }
                if (this.values.ecp_integration_result.response.descriptions[element].interactions) {
                  for (let decs in this.values.ecp_integration_result.response.descriptions[element].interactions) {
                    this.values.ecp_integration_result.response.descriptions[element].interactions[decs] = this.values.ecp_integration_result.response.descriptions[element].interactions[decs].replace(/<.*?>/g, '')
                  }
                }
              }
            }
          }
        }

        if (this.drugs_perm) {
          this.drugs_title = 'Низкий риск'
          if (this.values.ecp_integration_result) {
            if (this.drugs_value === '0' || this.drugs_value === '+1') { this.drugs_title = 'Низкий риск' }
            if (this.drugs_value === '1') { this.drugs_title = 'Умеренный риск' }
            if (this.drugs_value === '2') { this.drugs_title = 'Высокий риск' }
            if (this.drugs_value === '3' || this.drugs_value === '4') { this.drugs_title = 'Очень высокий риск' }
            if (this.drugs_value === '10' && this.drugs_perm) { this.drugs_title = 'Низкий риск' }
          }
          if (!this.values.ecp_integration_result) { this.drugs_title = 'Низкий риск' }
        }
        if (!this.drugs_perm) {
          this.drugs_title = 'Модуль не подключен'
        }

        this.is_set_drugs = true
        this.drug_index = this.contentIndex
        this.contentIndex += 1


        // tabs diagnosis (Подозрения на заболевани)
        this.suspicions = this.contentIndex
        this.contentIndex += 1



        for (let index = 0; index < this.contentIndex; index++) {
          this.$set(this.contentObj, index, false)
        }

        for (let onlyResult in this.nosology) {
          this.nosology[onlyResult].check_interpritation_exist = []
          if (this.nosology[onlyResult].risk_methods.length) {
            for (let riskMethod in this.nosology[onlyResult].risk_methods) {
              if (this.nosology[onlyResult].risk_methods[riskMethod].risk_group_code === 6) this.nosology[onlyResult].risk_methods[riskMethod].risk_group_code = 0
              if (this.nosology[onlyResult].risk_methods[riskMethod].description_text && this.nosology[onlyResult].risk_methods[riskMethod].description_text !== null) {
                this.nosology[onlyResult].check_interpritation_exist.push(
                  this.nosology[onlyResult].risk_methods[riskMethod]
                    .description_text
                )
              }
            }
            this.nosology[onlyResult].risk_methods.sort((a, b) => { return b.risk_group_code - a.risk_group_code })
          }
        }
      }
      if (this.groups.length && this.nosology) {
        for (let riskNosology in this.nosology) {
          for (let groupNosology in this.groups) {
            if (this.groups[groupNosology].plate_weight === null) { this.groups[groupNosology].plate_weight = 100 }
            if (this.nosology[riskNosology].nosology.code === this.groups[groupNosology].id && this.groups[groupNosology].plate_names_list && this.groups[groupNosology].plate_names_list.length) {
              this.groups[groupNosology].plate_names_list.forEach(element => {
                if (this.value.api_version === element.api_version) {
                  this.nosology[riskNosology].nosology.text = element.name
                }
              })
              this.nosology[riskNosology].nosology.plate_weight = this.groups[groupNosology].plate_weight

              if (this.groups[groupNosology].gender_filter === 'all') this.nosology[riskNosology].nosology.plate_gender = 0
              if (this.groups[groupNosology].gender_filter === 'not_detected') this.nosology[riskNosology].nosology.plate_gender = 3
              if (this.groups[groupNosology].gender_filter === 'male') this.nosology[riskNosology].nosology.plate_gender = 1
              if (this.groups[groupNosology].gender_filter === 'female') this.nosology[riskNosology].nosology.plate_gender = 2
            }
          }
        }
        this.nosology.sort((a, b) => { return a.nosology.plate_weight - b.nosology.plate_weight })
        this.nosology = this.uniq(this.nosology)
        for (let riskNosology in this.nosology) {
          if (this.values.images) {
            for (let inImages in this.values.images) {
              if (this.values.images[inImages].id === this.nosology[riskNosology].nosology.code) {
                this.nosology[riskNosology].nosology.images = this.values.images[inImages].image
                this.nosology[riskNosology].nosology.images_title = this.values.images[inImages].image_title
              }
            }
          }
        }
      }
    },
    setFttention () {
      if (this.value !== false) {
        if (this.value.patient_state) {
          if (this.value.patient_state === 1) this.value.patient_state_text = 'Удовлетворительное '
          if (this.value.patient_state === 2) this.value.patient_state_text = 'Относительно удовлетворительное '
          if (this.value.patient_state === 3) this.value.patient_state_text = 'Средней тяжести '
          if (this.value.patient_state === 4) this.value.patient_state_text = 'Тяжелое '
          if (this.value.patient_state === 5) this.value.patient_state_text = 'Агональное '
          if (this.value.patient_state === 6) this.value.patient_state_text = 'Коматозное '
        }
      }
    },
    uniq (a) {
      return a.filter(function (item, pos, ary) {
        return !pos || item !== ary[pos - 1]
      })
    },
    showMaxRiskTab () {
      this.nosology.forEach(item => {
        if (item.nosology.risk_group.code === 6) {
          item.nosology.risk_group.code = 0
        }
      })
    },
    showTabContent (index) {
      this.contentObj[index] = !this.contentObj[index]
    },
    toggleConflicts (item) {
      this.$set(item, 'expanded', !item.expanded)
    },
    tabDisplayCondition (result) {
      let tabcondition = (this.versions === this.variables.V1 && (result.nosology.code === 11 || result.nosology.code === 12 || result.nosology.code === 15)) ||
        (this.versions === variables.V2 && ((result.nosology.plate_gender === this.value.gender) || result.nosology.plate_gender === 0)) ||
        (this.versions === variables.V3 && ((result.nosology.plate_gender === this.value.gender) || result.nosology.plate_gender === 0))
      return tabcondition
    }
  },
  computed: {
    medicineRiskGroup () {
      return {
        'low_risk': this.drugs_value === '10' || this.drugs_value === '0' || this.drugs_value === '+1' || this.drugs_value === '+2' || (this.drugs_value !== '1' && this.drugs_value !== '2' && this.drugs_value !== '3' && this.drugs_value !== '4'),
        'medium_risk': this.drugs_value === '1',
        'high_risk': this.drugs_value === '2',
        'very_high_risk': this.drugs_value === '3' || this.drugs_value === '4'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/pageSummaryStyles2.sass"
.attention
  margin-left: 20px
  margin-bottom: 30px
  display: grid
  grid-template-columns: 100px auto
.attention_icons
  width: 80px
  margin-top: 10px
.attention_body_items
  display: flex
  margin-top: 20px
.attention_item_group
  display: grid
  grid-template-columns: auto auto
.attention_item
  display: grid
  grid-template-columns:  minmax(min-content,  120px) minmax(120px, 1fr)
.attention_item_header
  font-weight: bold
.attention_item_diag
  display: grid
  grid-template-columns:  30px minmax(min-content,  120px) minmax(120px, 1fr)
.drugTitle
  font-size: 16px
.conflictTies
  padding: 0 30px
.conflictTiesMain
  padding: 5px 0
.symptom_diag
  padding-left: 150px

.result__link
  text-decoration: none
  margin-bottom: 10px
  color: #595959

.result_text
  color: #212121

.tab-suspicions__content-row
  display: flex
  flex-wrap: wrap
  color: #212121
  font-weight: 700
  flex-flow: row nowrap
  height: 100%
  margin: 10px 0
.tab-suspicions__row-mkb-images--item
  margin: 0 5px
  &:nth-child(2)
    min-width: 50px
.tab-suspicions__detail-row
  padding-left: 102px
.tab-suspicions__document-link
  color: #595959
  a
    color: #595959
    text-decoration: underline
</style>
